import { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { lazyRetry } from "@/lib/lazyRetry";
import { Maximize2 } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

const PlanningWithProposals = lazyRetry(
  () => import("@/components/planning/PlanningWithProposals")
);

interface PlanningDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function PlanningDrawer({ open, onOpenChange }: PlanningDrawerProps) {
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-lg h-[100dvh] overflow-y-auto p-0">
        <SheetHeader className="px-6 pt-6 pb-2 flex flex-row items-center justify-between">
          <SheetTitle>Planning</SheetTitle>
          <button
            onClick={() => {
              onOpenChange(false);
              navigate("/planning");
            }}
            className="flex items-center gap-1.5 text-xs text-primary hover:text-primary/80 transition-colors min-h-[44px] px-2"
            aria-label="Voir la semaine complète"
          >
            <Maximize2 className="h-3.5 w-3.5" />
            Semaine complète
          </button>
        </SheetHeader>
        <div className="px-4 pb-6">
          <Suspense
            fallback={
              <div className="flex items-center justify-center py-12 text-muted-foreground text-sm">
                Chargement…
              </div>
            }
          >
            {open && <PlanningWithProposals />}
          </Suspense>
        </div>
      </SheetContent>
    </Sheet>
  );
}
